import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=bef2009a&"
import script from "./FollowButton.vue?vue&type=script&lang=js&"
export * from "./FollowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports